import { useEffect } from "react";
import { useMe } from "@/data/user.ts";
import { useSEO } from "@/contexts/SeoContext.tsx";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints.ts";
import { useTranslation } from "react-i18next";
import MobileView from "@/components/diploma-requests/MobileView.tsx";
import PageHeading from "@/components/ui/PageHeading.tsx";
import DesktopView from "@/components/diploma-requests/DesktopView.tsx";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";

export default function DiplomaRequest() {
  const { t } = useTranslation();
  const { me } = useMe();
  const breakpoint = useBreakpoint();
  const { setTitle, setDescription } = useSEO();

  const isSmallScreen = ["xs", "sm", "md"].indexOf(breakpoint) !== -1;

  useEffect(() => {
    setTitle(
      `${me?.item.user.first_name} ${me?.item.user.last_name} | Diploma Request`,
    );
    setDescription("Diploma Request Page");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me]);

  return (
    <DashboardContentLayout className="until-lg:flex until-lg:pb-0 flex-col flex-1 overflow-y-auto until-lg:px-0 h-full">
      <PageHeading
        title={t("menu.diploma")}
        subtitle={t("diploma_request.sub_header")}
        titleClassName={isSmallScreen ? "!text-brand px-4" : ""}
        subtitleClassName={isSmallScreen ? "text-brand px-4" : ""}
      />

      {isSmallScreen ? <MobileView /> : <DesktopView />}
    </DashboardContentLayout>
  );
}
